import { Pipe, PipeTransform } from '@angular/core';

import { Store } from '@ngrx/store';

import { AppState, getMyAuth } from 'src/app/store/app.state';
import { take } from 'rxjs/operators';
import memo from 'memo-decorator';

/**Pure pipe che recupera il colore da visualizzare per un certo tipo di glossario */
@Pipe({
  name: 'glossaryColor',
  pure: true
})
export class GlossaryColorPipe implements PipeTransform {

  /**
   * Costruttore per GlossaryColorPipe
   * @param store {store<AppState>} stato a livello dell'applicazione
   */
  constructor(private store: Store<AppState>) {}

  /**
   * Metodo dell'interfaccia PipeTransform
   * @param voceGlos {Glossary} voce di glossario per la quale identificare il colore del tipo
   * @returns {object}
   */
  @memo()
  transform(voceGlosType: string): {} {
    let color: string = '';
    this.store.select(getMyAuth).pipe(take(1)).subscribe( data => {
      let glosType = data.glossaryTypeList.find(glosType => {
        return glosType.name === voceGlosType;
      });
      if(glosType) {
        color = glosType.color;
      }
    })
    return {'color': color, 'font-size': '15px'};
  }

}
